import { create } from 'zustand';
import { WorkspaceFilterGroup } from '../services/workspace-filter-groups.service';

interface WorkspaceFilterGroupsState {
  filterGroups: WorkspaceFilterGroup[];
  setFilterGroups: (groups: WorkspaceFilterGroup[]) => void;
  addFilterGroup: (group: WorkspaceFilterGroup) => void;
  updateFilterGroup: (group: WorkspaceFilterGroup) => void;
  removeFilterGroup: (id: string) => void;
  getById: (id: string) => WorkspaceFilterGroup | undefined;
}

export const useWorkspaceFilterGroupsStore = create<WorkspaceFilterGroupsState>((set, get) => ({
  filterGroups: [],
  setFilterGroups: (filterGroups) => set({ filterGroups }),
  addFilterGroup: (group) =>
    set((state) => ({ filterGroups: [...state.filterGroups, group] })),
  updateFilterGroup: (group) =>
    set((state) => ({
      filterGroups: state.filterGroups.map((g) => (g.id === group.id ? group : g)),
    })),
  removeFilterGroup: (id) =>
    set((state) => ({
      filterGroups: state.filterGroups.filter((g) => g.id !== id),
    })),
  getById: (id) => get().filterGroups.find((g) => g.id === id),
}));
